import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'
Vue.use(Vuex)
//init store
const store = new Vuex.Store({
    state: {
        isLoggedIn: !!localStorage.getItem('userName'),       
        route: router
    },
    getters: {
    },
    mutations: {
        setGlobalError(state, error) {
            state.globalError = error
        }
    },
    actions: {
    }
})
export default store